"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Radio_1 = __importDefault(require("@mui/material/Radio"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const material_1 = require("@mui/material");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const LanguageWrapper = styled_components_1.default.div `
  width: 100%;
  background: #fff;
  height: 100%;
  overflow: auto;
`;
const Language = (props) => {
    const { updateStore, enabledLocales, currentLocale } = props;
    const updateUserSelectedLocale = (selectedLocale) => {
        if (selectedLocale !== currentLocale) {
            localStorage.setItem('language', selectedLocale);
            updateStore('userSelectedLocale', selectedLocale);
        }
    };
    const renderLanguages = () => enabledLocales.map(item => (react_1.default.createElement("div", { key: (0, react_uid_1.uid)(item) },
        react_1.default.createElement(material_1.ListItem, { disablePadding: true },
            react_1.default.createElement(material_1.ListItemButton, { style: {
                    flexDirection: 'row-reverse',
                }, onClick: () => {
                    if (window.usercentrics) {
                        window.usercentrics.updateLanguage(item.abbreviation);
                    }
                    updateUserSelectedLocale(item.abbreviation);
                } },
                react_1.default.createElement(material_1.ListItemIcon, null,
                    react_1.default.createElement(Radio_1.default, { edge: "start", checked: currentLocale === item.abbreviation, tabIndex: -1, disableRipple: true })),
                react_1.default.createElement(material_1.ListItemText, { primary: item.name }))),
        react_1.default.createElement(material_1.Divider, null))));
    return (react_1.default.createElement(LanguageWrapper, null,
        react_1.default.createElement(material_1.List, { sx: { width: '100%' } }, renderLanguages())));
};
const mapStoreToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(Language);
